import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaTrash, FaCheck } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Paginacao from '../../common/pagination';
import { IMaskInput } from "react-imask";
import { tipoUsuarioDashboard } from "../../common/utils";

class ProgramaDashboard extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listDashboard: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,
            
            // Modal
            showModal: false,
            modalTitulo: '',
            
            // Campos do formulário
            id: null,
            tipo_usuario: '',
            titulo: '',
            link: '',
            imagem: '',
            imagemPreview: null,
            
            // Erros de validação
            tipoUsuarioError: '',
            tituloError: '',
            linkError: '',
        };
    }

    componentDidMount() {
        this.carregarDashboard(this.state.page_numb);
    }

    carregarDashboard = (page_numb = 1) => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, error: 'ID do programa não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/programas/dashboard/?programa_id=${programaId}&page=${page_numb}`)
            .then(response => {
                this.setState({
                    listDashboard: response.data,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar dashboard';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.carregarDashboard(num_page);
    }

    abrirModalNovo = () => {
        this.setState({
            showModal: true,
            modalTitulo: 'Adicionar Dashboard',
            id: null,
            titulo: '',
            link: '',
            tituloError: '',
            linkError: '',
            tipoUsuarioError: '',
        });
    };

    abrirModalEditar = (item) => {
        this.setState({
            showModal: true,
            modalTitulo: 'Editar Dashboard',
            id: item.id,
            tipo_usuario: item.tipo_usuario || '',
            titulo: item.titulo || '',
            link: item.link || '',
            imagem: null,
            imagemPreview: item.imagem || null,
            tituloError: '',
            linkError: '',
            tipoUsuarioError: '',
        });
    };

    fecharModal = () => {
        this.setState({
            showModal: false,
            id: null,
            tipo_usuario: '',
            titulo: '',
            link: '',
            imagem: null,
            imagemPreview: null
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, [`${name}Error`]: '' });
    };

    onChangeImagem = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({imagem: file, imagemPreview: URL.createObjectURL(file)});
        }
    };

    validarFormulario = () => {
        let valido = true;

        if (!this.state.titulo.trim()) {
            this.setState({ tituloError: 'titulo é obrigatório' });
            valido = false;
        }

        if (!this.state.tipo_usuario.trim()) {
            this.setState({ tipoUsuarioError: 'Tipo usuário é obrigatório' });
            valido = false;
        }
        
        return valido;
    };

    salvar = async () => {
        if (!this.validarFormulario()) return;

        const { programaId } = this.props;
        const { id, titulo, link, tipo_usuario, imagem } = this.state;

        this.setState({ loadingModal: true });

        const formData = new FormData();
        formData.append('programa_id', programaId);
        formData.append('titulo', titulo);
        formData.append('link', link);
        formData.append('tipo_usuario', tipo_usuario);

        if (imagem) {
            formData.append('imagem', imagem); 
        }

        const url = id ? `/programas/dashboard/${id}/` : '/programas/dashboard/';
        const metodo = id ? 'put' : 'post';

        try {
            await api({
                method: metodo,
                url: url,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            Swal.fire({
                icon: 'success', title: id ? 'Dashboard atualizado com sucesso' : 'Dashboard cadastrado com sucesso'
            });

            this.setState({ loadingModal: false });
            this.fecharModal();
            this.carregarDashboard(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao salvar';

            if (error.response?.status === 500) {
                erro_msg = 'Servidor indisponível';
            }

            Swal.fire({
                icon: 'error',
                title: erro_msg
            });
            
            this.setState({ loadingModal: false });
        }
    };


    excluir = (item) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Você tem certeza?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await api.delete(`/programas/dashboard/${item.id}/`);

                    MySwal.fire(
                        'Excluído!',
                        'Dashboard excluído com sucesso.',
                        'success'
                    );

                    this.carregarDashboard(this.state.page_numb);

                } catch (error) {
                    let erro_msg = 'Erro ao excluir';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: erro_msg,
                    });
                }
            }
        });
    };

    renderRows = () => {
        if ('results' in this.state.listDashboard && this.state.listDashboard.results.length > 0) {
            return this.state.listDashboard.results.map((item) => (
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.tipo_usuario}</td>
                    <td>{item.titulo}</td>
                    <td>{item.link}</td>
                    <td>
                        <Button variant="light" size="sm" className="me-1" onClick={() => this.abrirModalEditar(item)}>
                            <FaRegEdit /> Editar
                        </Button>
                        <Button variant="danger"  size="sm" onClick={() => this.excluir(item)} >
                            <FaTrash /> Excluir
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={6}>Nenhuma dashboard cadastrado para este programa</td>
            </tr>
        );
    };

    render() {
        const { 
            loading, 
            loadingModal,
            error, 
            listDashboard,
            page_numb,
            showModal,
            modalTitulo,
            titulo,
            tituloError,
            link,
            linkError,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h4>Dashboard</h4>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                <Button variant="secondary" size="sm" onClick={this.abrirModalNovo}>
                                    <FaPlus /> Adicionar Dashboard
                                </Button>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Tipo Usuário</th>
                                    <th>Título</th>
                                    <th>Link</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={6}>Carregando...</td>
                                    </tr>
                                ) : (
                                    error ? (
                                        <tr>
                                            <td colSpan={6}>{error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        {'results' in listDashboard && listDashboard.results.length > 0 && 
                            <Paginacao 
                                dados={listDashboard} 
                                loading={loading} 
                                page_numb={page_numb} 
                                _onClickPagina={this.onClickPagina} 
                            />
                        }
                    </Card.Body>
                </Card>

                {/* Modal Cadastro/Edição */}
                <Modal  show={showModal} onHide={this.fecharModal} size="lg" backdrop="static" >
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo Usuário <span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control as="select" name="tipo_usuario" value={this.state.tipo_usuario} required onChange={this.handleChange}>
                                            <option value="">Tipo de Usuário</option>
                                            {Object.entries(tipoUsuarioDashboard).map(([sigla, nome]) => (
                                                <option key={sigla} value={sigla}>{nome}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Título <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="titulo"
                                            value={titulo}
                                            onChange={this.handleChange}
                                            placeholder="Título"
                                        />
                                        {tituloError && (
                                            <Form.Text className="text-danger">{tituloError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Link</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="link"
                                            value={link}
                                            onChange={this.handleChange}
                                            placeholder="Link"
                                        />
                                        {linkError && ( <Form.Text className="text-danger">{linkError}</Form.Text>)}
                                    </Form.Group>
                                </Col>
                                 <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Imagem</Form.Label>
                                        <Form.Control  type="file"  name="imagem"  accept="image/*" onChange={this.onChangeImagem}/>
                                        {this.state.imagemPreview && (
                                            <div className="mt-2">
                                                <img src={this.state.imagemPreview}  alt="Preview"  style={{ maxWidth: '120px', borderRadius: '4px' }} />
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>
                            Cancelar
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={this.salvar}
                            disabled={loadingModal}
                        >
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ProgramaDashboard;
